import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps"
import { useEffect, useState } from "react"

export const useDrawingManager = () => {
  const map = useMap()
  const drawing = useMapsLibrary("drawing")

  const [drawingManager, setDrawingManager] =
    useState<google.maps.drawing.DrawingManager | null>(null)

  useEffect(() => {
    if (!map || !drawing) return

    const newDrawingManager = new drawing.DrawingManager({
      map,
      drawingControl: null,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.CIRCLE,
          google.maps.drawing.OverlayType.POLYGON,
          google.maps.drawing.OverlayType.RECTANGLE,
        ],
      },
      circleOptions: {
        editable: true,
        draggable: true,
      },
      polygonOptions: {
        editable: true,
        draggable: true,
      },
      rectangleOptions: {
        editable: true,
        draggable: true,
      },
    })

    setDrawingManager(newDrawingManager)

    return () => {
      newDrawingManager.setMap(null)
    }
  }, [drawing, map])

  return drawingManager
}
